import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getUserProfile } from '../utils/database';
import DashboardSidebar from '../components/DashboardSidebar';
import BottomNav from '../components/BottomNav';
import '../styles/Dashboard.css';
import '../styles/Notifications.css';

function Notifications() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      try {
        if (!currentUser || currentUser.uid !== userId) {
          navigate('/signin');
          return;
        }

        const userData = await getUserProfile(userId);
        if (!userData) {
          navigate('/onboarding');
          return;
        }

        setUser(userData);
        setLoading(false);
      } catch (error) {
        console.error('[Notifications] Error loading user:', error);
        navigate('/signin');
      }
    });

    return () => unsubscribe();
  }, [userId, navigate]);

  // Don't show loading screen - render layout immediately

  return (
    <>
    <div className="dashboard-page has-bottom-nav">
      {/* Background effects */}
      <div className="dashboard-bg-glow dashboard-bg-glow-1" />
      <div className="dashboard-bg-glow dashboard-bg-glow-2" />
      <div className="dashboard-overlay" />

      {/* Sidebar */}
      <DashboardSidebar userId={userId} user={user} />

      {/* Main content */}
      <div className="dashboard-main">
        {/* Header */}
        <div className="dashboard-header">
          <div className="dashboard-greeting">
            <h1>Notifications</h1>
            <p className="dashboard-quote">Stay updated on your account, program, and community</p>
          </div>
        </div>

        {/* Notifications Grid */}
        <div className="notifications-grid">
          {/* Account Notifications */}
          <div className="notifications-section">
            <div className="notifications-section-header">
              <div className="notifications-section-icon">👤</div>
              <div className="notifications-section-info">
                <h2>Account</h2>
                <p>Security alerts, profile updates, and account activity</p>
              </div>
              <span className="notifications-badge">0</span>
            </div>
            <div className="notifications-list">
              <div className="notifications-empty">
                <p>No account notifications</p>
              </div>
            </div>
          </div>

          {/* Program Notifications */}
          <div className="notifications-section">
            <div className="notifications-section-header">
              <div className="notifications-section-icon">📋</div>
              <div className="notifications-section-info">
                <h2>Program</h2>
                <p>Workout reminders, program updates, and coaching messages</p>
              </div>
              <span className="notifications-badge">0</span>
            </div>
            <div className="notifications-list">
              <div className="notifications-empty">
                <p>No program notifications</p>
              </div>
            </div>
          </div>

          {/* Company Notifications */}
          <div className="notifications-section">
            <div className="notifications-section-header">
              <div className="notifications-section-icon">🏢</div>
              <div className="notifications-section-info">
                <h2>Begin Strength</h2>
                <p>Announcements, new features, and community updates</p>
              </div>
              <span className="notifications-badge">0</span>
            </div>
            <div className="notifications-list">
              <div className="notifications-empty">
                <p>No company announcements</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom Navigation - Mobile/Tablet */}
    <BottomNav userId={userId} user={user} />
    </>
  );
}

export default Notifications;











